import React from "react";
// import "../styles/h1.css";
const Heading = (props: any) => {
  return (
    <div className="heading">
      <h2 style={{ textAlign: "center" }}>{props.heading}</h2>
    </div>
  );
};

export default Heading;